export async function preloadImages(
  container: HTMLElement,
  timeoutMs: number
): Promise<void> {
  const images = container.querySelectorAll<HTMLImageElement>('img');
  await Promise.allSettled(
    Array.from(images, (img) => {
      img.loading = 'eager';
      return Promise.race([
        img.decode(),
        new Promise((_, reject) => setTimeout(reject, timeoutMs)),
      ]).catch(() => img.remove());
    })
  );
}
